import { Box, styled } from "@mui/material";

export const EditorRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

export const EditorTopBar = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor.default};
  flex-shrink: 0;
`;

export const EditorBody = styled(Box)`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const LeftPanel = styled(Box)`
  width: 240px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-inline-end: 1px solid ${({ theme }) => theme.palette.borderColor.default};
  overflow: hidden;
`;

export const RightPanel = styled(Box)`
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-inline-start: 1px solid ${({ theme }) => theme.palette.borderColor.default};
  overflow-y: auto;
  padding: 12px;
  gap: 12px;
`;

export const CenterPanel = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.background.secondary};
  overflow: hidden;
  position: relative;
`;

export const CanvasWrapper = styled(Box)`
  position: relative;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.18);
`;

export const LayerRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  padding-inline-start: ${({ selected }) => (selected ? "4px" : "8px")};
  cursor: pointer;
  border-radius: 6px;
  border-inline-start: ${({ selected, theme }) =>
    selected ? `4px solid ${theme.palette.action?.main || theme.palette.primary.main}` : "4px solid transparent"};
  background: ${({ selected, theme }) =>
    selected ? theme.palette.background.dark : "transparent"};
  &:hover {
    background: ${({ theme }) => theme.palette.background.dark};
  }
`;

export const LayersList = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding: 4px;
`;

export const AddButtonsRow = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor.default};
`;

export const PropSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PropRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ColorSwatch = styled(Box)`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor.dark};
  background: ${({ color }) => color || "#000"};
  cursor: pointer;
  flex-shrink: 0;
`;

export const ColorPickerPopover = styled(Box)`
  position: absolute;
  z-index: 9999;
  margin-top: 4px;
`;
